import { CommunityChannelApi } from '@ps/api/community-channel';
import { withClientAPI } from '@ps/functions/utils/api';

/**
 * Pin or un-pin a channel message. The server flips the message
 * doc's `pinnedAt` field — local state catches up via the existing
 * Firestore message subscription. `remove: true` un-pins; default
 * pins.
 */
export async function togglePinMessage({
  creatorId,
  channelId,
  messageId,
  remove,
}: {
  creatorId: string;
  channelId: string;
  messageId: string;
  remove: boolean;
}): Promise<void> {
  const api = withClientAPI(CommunityChannelApi);
  await api.communityChannelApiControllerToggleCommunityChannelMessagePin({
    sellerId: creatorId,
    channelId,
    messageId,
    ToggleCommunityChannelMessagePinRequest: { remove },
  });
}
